<template>
    <div>
        <div class="modal-lg" v-if="showTransferInstanceModal == true">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <h1>Airport Transfer</h1>
                        </div>
                    </div>
                    <hr />
                    <div class="container">
                        <div class="row">
                            <div class="col-md-4">
                                <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(activeTab == 'outbound') ? 'active':null" @click="switchTab('outbound')">
                                    Outbound Flights
                                </a>
                            </div>
                            <div class="col-md-4">
                                <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(activeTab == 'inbound') ? 'active':null" @click="switchTab('inbound')">
                                    In-Bound Flights
                                </a>
                            </div>
                        </div>
                    </div>
                    <template v-if="activeTab == 'outbound'">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <table class="table" cellspacing="0" cellpadding="0">
                                    <thead>
                                    <tr>
                                        <th>Departure Airport</th>
                                        <th>Arrival Airport</th>
                                        <th>Time</th>
                                        <th>No of Pax</th>
                                        <th>Transfer</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="outBoundFlights.length > 0">
                                            <tr v-for="(bookingFlight, index) of outBoundFlights" :key="index">
                                                <td>
                                                    {{ `${bookingFlight.departure_airport_iata_code} (${bookingFlight.departure_airport_airport_name})`  }}
                                                </td>
                                                <td>
                                                    {{ `${bookingFlight.arrival_airport_iata_code} (${bookingFlight.arrival_airport_airport_name})`  }}
                                                </td>
                                                <td>
                                                    <b>{{ bookingFlight.arrival_time | formatTimeShort  }}</b>
                                                </td>
                                                <td>
                                                    {{ bookingFlight.passenger_count }}
                                                </td>
                                                <td>
                                                    <input type="text"
                                                        class="form-control" 
                                                        :name="`transfer_${index}`"
                                                        :id="`transfer_${index}`" 
                                                        placeholder="-"
                                                        v-model="bookingFlight.departure_transfer"
                                                    >
                                                </td>
    
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <button class="button mt-1" @click="updateInstanceTransfer('outbound')">
                                    <span> Update Transfer </span>
                                </button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="activeTab == 'inbound'">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <table class="table" cellspacing="0" cellpadding="0">
                                    <thead>
                                    <tr>
                                        <th>Departure Airport</th>
                                        <th>Arrival Airport</th>
                                        <th>Time</th>
                                        <th>No of Pax</th>
                                        <th>Transfer</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="inboundFlightsClone.length > 0">
                                            <tr v-for="(bookingFlight, index) of inboundFlightsClone" :key="index">
                                                <td>
                                                    {{ `${bookingFlight.departure_airport_iata_code} (${bookingFlight.departure_airport_airport_name})`  }}
                                                </td>
                                                <td>
                                                    {{ `${bookingFlight.arrival_airport_iata_code} (${bookingFlight.arrival_airport_airport_name})`  }}
                                                </td>
                                                <td>
                                                    <b>{{ bookingFlight.arrival_time | formatTimeShort  }}</b>
                                                </td>
                                                <td>
                                                    {{ bookingFlight.passenger_count }}
                                                </td>
                                                <td>
                                                    <input type="text"
                                                        class="form-control" 
                                                        :name="`transfer_${index}`"
                                                        :id="`transfer_${index}`" 
                                                        placeholder="-"
                                                        v-model="bookingFlight.departure_transfer"
                                                    >
                                                </td>
    
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr/>
                        <template v-if="showPickUps">
                            <div class="row mt-3" v-if="inBoundTransfers.length > 0 && inBoundAccomodations.length > 0">
                                <div class="col-md-12">
                                    <table class="table" cellspacing="0" cellpadding="0">
                                        <thead>
                                        <tr>
                                            <th>Transfer</th>
                                            <th v-for="(accomodation, index) in inBoundAccomodations" :key="index">
                                                <div class="form-group">
                                                    <select class="form-select" 
                                                        style="height: auto;" 
                                                        v-model="selectedTransferAccommodations[index]"
                                                        @change="syncPickups()">
                                                        <option value="">Select</option>
                                                        <option v-for="(acc_option, acc_index) in inBoundAccomodations" 
                                                            :key="acc_index" 
                                                            :value="acc_option.accommodation_id"
                                                            :disabled="selectedAccomodation.includes(acc_option.accommodation_id)"
                                                        >
                                                            {{ acc_option.details.accommodation_name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(inBoundTransfer, index_transfer) in inBoundTransfers">
                                                <tr :key="index_transfer">
                                                    <td>{{ inBoundTransfer }}</td>
                                                    <td v-for="(accomodation, index_accomodation) in inBoundAccomodations" :key="index_accomodation">
                                                        <div class="form-group">
                                                          <label for="">Pickup Time</label>
                                                          <input type="time" 
                                                            class="form-control" 
                                                            :data-transfer="inBoundTransfer" 
                                                            :data-acc-id="accomodation.accommodation_id"
                                                            :value="getPickupTime(inBoundTransfer, index_accomodation)"
                                                            @input="setPickupTime($event.target.value, inBoundTransfer, index_accomodation)"
                                                            placeholder="Pickup Time">
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                           
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr/>
                        </template>

                        <div class="row mt-3">
                            <div class="col-md-12">
                                <button class="button mt-1" @click="updateInstanceTransfer('inbound')">
                                    <span> Update Transfer </span>
                                </button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <button type="button" class="icon icon--unlink" v-on:click="closeModal">Close</button>
        </div>
        <div class="modal__bg" v-if="showTransferInstanceModal == true"></div>
    </div>
</template>

<script>
export default {
    name: 'TourGroupInstanceTransfer',
    props: {
        showTransferInstanceModal: {
            type: Boolean,
            required: true,
            default: false
        },
        tourGroupInstances: {
            type: Array,
            required: true,
            default: []
        },
        GroupInstancesTransfers: {
            type: Array,
            required: false,
            default: []
        },
        departure_date: {
            type: String,
            required: true,
            default: null
        },
        accomodations: {
            type: Array,
            required: true,
            default: []
        }
    }, 
    watch: {
        inboundFlightsClone: {
            handler(newValue, oldValue) {
                if (newValue) {
                    const availableTransfers = [
                        ...new Set(newValue.map(item => item.departure_transfer).filter(t => t && t.trim() !== ""))
                    ];
                    let transferArray = [];
                    availableTransfers.forEach((transfer) => {
                        if (transfer && transfer.trim() !== "") {
                            transferArray.push(transfer);
                        }
                    });
                    this.inBoundTransfers = transferArray;
                }
            },
            deep: true
        }
    },  
    data() {
        return {
            inBoundTransfers: [],
            inboundFlightsClone: [],
            inBoundAccomodations: [],
            selectedAccomodation: [],
            activeTab: 'outbound',
            selectedTransferAccommodations: [],
            pickupTimings: {},
            showPickUps: false, 
        }  
    },
    computed: {
        bookingFlights() {
            let tourBookingFLights = [];
            const tourDate = new Date(this.departure_date).setHours(0, 0, 0, 0);
            
            if (this.tourGroupInstances.length > 0) {
                this.tourGroupInstances.forEach((tourGroupInstance) => {
                    let departureFlighArray = [];
                    let returnFlightArray = [];
                    
                    if (tourGroupInstance && tourGroupInstance.flights.length > 0) {
                        if (tourGroupInstance.flights.length === 2) {
                            departureFlighArray.push(tourGroupInstance.flights[0])
                            returnFlightArray.push(tourGroupInstance.flights[1])
                        }else{
                            // Get Inbound Flights Array
                            let inboundFlights = tourGroupInstance.flights.filter((item) => item.pivot.indirect_inbound == 1)
                            // Get Outbount Flights Array
                            let outBoundFlights = tourGroupInstance.flights.filter((item) => item.pivot.indirect_outbound == 1)

                            if (inboundFlights.length > 0) {
                                returnFlightArray = inboundFlights
                            } else {
                                returnFlightArray.push(tourGroupInstance.flights.reduce((carry, flight) => {
                                    const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                                    return (flightDate !== tourDate) ? flight : carry;
                                }, null))
                            }

                            if (outBoundFlights.length > 0 ) {
                                departureFlighArray = outBoundFlights
                            } else {
                                departureFlighArray.push(tourGroupInstance.flights.reduce((carry, flight) => {
                                    const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                                    return (flightDate === tourDate) ? flight : carry;
                                }, null))
        
                            }
                        }

                        tourBookingFLights.push({
                            'tour_group_instance_id': tourGroupInstance.instance_id,
                            'departure_flights': departureFlighArray,
                            'return_flights': returnFlightArray,
                            'pax_count': tourGroupInstance.pax_count,
                        })
                    }
                });
                
            }
            return tourBookingFLights
        },
        outBoundFlights() {
            let outBoundFlights = [];
            if (this.bookingFlights.length > 0) {
                this.bookingFlights.forEach((bookingFlight) => {
                    let departureFlightData = {}

                    if (bookingFlight.departure_flights.length == 0) {
                        departureFlightData =  bookingFlight.departure_flights[0]
                    } else {
                        departureFlightData = bookingFlight.departure_flights[bookingFlight.departure_flights.length - 1] 
                    }

                    if (departureFlightData) {

                        let foundGroupInstanceTransfer = this.GroupInstancesTransfers.find((item) => {
                            return item.flight_id == departureFlightData.id && item.tour_instance_id == bookingFlight.tour_group_instance_id
                        })

                        if (foundGroupInstanceTransfer) {
                            departureFlightData.departure_transfer = foundGroupInstanceTransfer.transfer
                        } else {
                            departureFlightData.departure_transfer = ''
                        }
                        
                        
                        outBoundFlights.push({
                            flight_id: departureFlightData.id,
                            instance_id: bookingFlight.tour_group_instance_id,
                            departure_airport_iata_code: departureFlightData.departure_airport.iata_code,
                            departure_airport_airport_name: departureFlightData.departure_airport.airport_name,
                            arrival_airport_iata_code: departureFlightData.arrival_airport.iata_code,
                            arrival_airport_airport_name: departureFlightData.arrival_airport.airport_name,
                            arrival_time: departureFlightData.arrival_time,
                            passenger_count: bookingFlight.pax_count,
                            departure_transfer: departureFlightData.departure_transfer,
                        })
                    }
                })
                
            }

            // Sort the outbound flights by arrival time
            outBoundFlights.sort((a, b) => new Date(a.arrival_time) - new Date(b.arrival_time));

            return outBoundFlights
        },
    },
    methods: {
        closeModal() {
            this.inBoundTransfers = []
            this.inboundFlightsClone = []
            this.inBoundAccomodations = []
            this.selectedAccomodation = []
            this.activeTab = 'outbound';
            this.selectedTransferAccommodations = []
            this.pickupTimings = {}
            this.showPickUps = false
            this.$emit('closeModal') 
        },
        updateInstanceTransfer(transfer_for) {
            let transferData = [];
            let pickupTimes = [];
            if (transfer_for === 'outbound') {
                this.outBoundFlights.forEach((bookingFlight, index) => {
                    if (bookingFlight.departure_transfer) {
                        transferData.push({
                            'transfer': bookingFlight.departure_transfer,
                            'flight_id': bookingFlight.flight_id,
                            'instance_id': bookingFlight.instance_id,
                        })
                    }
                })
                
            } else if (transfer_for === 'inbound') {
                this.inboundFlightsClone.forEach((bookingFlight, index) => {
                    if (bookingFlight.departure_transfer) {
                        transferData.push({
                            'transfer': bookingFlight.departure_transfer,
                            'flight_id': bookingFlight.flight_id,
                            'instance_id': bookingFlight.instance_id,
                        })
                    }
                })


            } 
            
            if (transferData.length === 0) {
                this.$notify({
                    type: 'error',
                    title: 'Please add transfer'
                });
                return;
            }

            let newPickUpTimings = Object.fromEntries(
                Object.entries(this.pickupTimings).filter(([key]) =>
                    this.inBoundTransfers.includes(key)
                )
            );

            fetch(`${this.$api}tours/groups/${this.$route.params.id}/update-instances-transfers`, {
                method: 'POST',
                body: JSON.stringify({
                    'transfer_for': transfer_for,
                    'transfer_data': transferData,
                    'pickup_times': newPickUpTimings,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
               if (response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            })
            
        },
        async switchTab(tab) {
            if (tab == 'inbound') {
                let inboundFlights = await this.makeInboundFlightArray();
                let commonAccomodations = await this.setCommonAccomodations();
                this.inboundFlightsClone = inboundFlights;
                this.inBoundAccomodations = commonAccomodations;
                this.getTransferPickUpTimes()
                this.activeTab = tab;
            }else {
                this.activeTab = tab;
            }
        },
        makeInboundFlightArray() {
            let __this = this;
            return new Promise((resolve, reject) => {
                let inBoundFlights = [];
                if (__this.bookingFlights.length > 0) {
                    __this.bookingFlights.forEach((bookingFlight) => {
                        let returnFlightData = {}

                        returnFlightData =  bookingFlight.return_flights[0]
                        
                        if (returnFlightData) {

                            let foundGroupInstanceTransfer = this.GroupInstancesTransfers.find((item) => {
                                return item.flight_id == returnFlightData.id && item.tour_instance_id == bookingFlight.tour_group_instance_id
                            })

                            if (foundGroupInstanceTransfer) {
                                returnFlightData.departure_transfer = foundGroupInstanceTransfer.transfer
                            } else {
                                returnFlightData.departure_transfer = ''
                            }

                            inBoundFlights.push({
                                flight_id: returnFlightData.id,
                                instance_id: bookingFlight.tour_group_instance_id,
                                departure_airport_iata_code: returnFlightData.departure_airport.iata_code,
                                departure_airport_airport_name: returnFlightData.departure_airport.airport_name,
                                arrival_airport_iata_code: returnFlightData.arrival_airport.iata_code,
                                arrival_airport_airport_name: returnFlightData.arrival_airport.airport_name,
                                arrival_time: returnFlightData.departure_time,
                                passenger_count: bookingFlight.pax_count,
                                departure_transfer: returnFlightData.departure_transfer,
                            })
                        }
                    })
                    
                }
                // Sort the outbound flights by arrival time
                inBoundFlights.sort((a, b) => new Date(a.arrival_time) - new Date(b.arrival_time));
                resolve(inBoundFlights);
            });
        },
        setCommonAccomodations() {
            let __this = this;
            return new Promise((resolve, reject) => {
                if (__this.accomodations.length > 0) {
                    const uniqueByAccommodationId = __this.accomodations.filter((item, index, arr) => 
                        arr.findIndex(obj => obj.accommodation_id === item.accommodation_id) === index
                    );
                    resolve(uniqueByAccommodationId);
                }
                
            });
        },
        getPickupTime(transfer, accId_index) {
            if (!this.pickupTimings[transfer]) {
                this.$set(this.pickupTimings, transfer, {});
            }
            return this.pickupTimings[transfer][this.selectedTransferAccommodations[accId_index]] || '';
        },
        setPickupTime(value, transfer, accId_index) {
            if (!this.pickupTimings[transfer]) {
                this.$set(this.pickupTimings, transfer, {});
            }
            this.$set(this.pickupTimings[transfer], this.selectedTransferAccommodations[accId_index], value);
        },
        initPickupCell(transfer, accId, value='') {
            if (!this.pickupTimings[transfer]) {
                this.$set(this.pickupTimings, transfer, {});
            }
            if (!this.pickupTimings[transfer][accId]) {
                this.$set(this.pickupTimings[transfer], accId, value);
            }
        },
        getTransferPickUpTimes() {
            let __this = this;
            setTimeout(() => {
                fetch(`${this.$api}tours/groups/${this.$route.params.id}/get-instance-pickups`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    if (response.status) {
                        this.showPickUps = true;
                        if (response.data.group_common_accomodation_ids.length > 0 ) {
                            __this.selectedTransferAccommodations = response.data.group_common_accomodation_ids.map((item) => item.accommodation_id);
                            let addedPickups = response.data.group_transfer_pickups
                            for (let index = 0; index < response.data.group_common_accomodation_tranafers.length; index++) {
                                for (let j = 0; j < response.data.group_common_accomodation_ids.length; j++) {
                                    let pickupValue = __this.findPickupValue(addedPickups, response.data.group_common_accomodation_tranafers[index]['transfer_name'], response.data.group_common_accomodation_ids[j].accommodation_id);
                                    __this.initPickupCell(response.data.group_common_accomodation_tranafers[index]['transfer_name'], response.data.group_common_accomodation_ids[j].accommodation_id, pickupValue);
                                }
                                
                            }
                        }
                    } 
                })
            }, 300);
        },
        findPickupValue(pickupArray, transfer, accomodation) {
            if (pickupArray && pickupArray.length > 0) {
                let foundPickup = pickupArray.find((item) => {
                    return item.transfer_name === transfer && item.accommodation_id === accomodation;
                });
                return foundPickup ? foundPickup.pickup_time : '';
            }
            return '';
        },
        syncPickups() {
            this.inBoundTransfers.forEach(element => {
                this.pickupTimings[element] = {};
            });
        }
    }  
}
</script>
<style scoped>
.menu-link {
  display: block;
  height: 60px;
  padding: 15px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #000;
  background-color: #fff;
  border: 1px solid #dee2e6;
  font-size: 18px;
  font-weight: bold;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.menu-link.active {
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
}
</style>
